import React from 'react';

import { useUrlHydration } from '../hooks/useUrlHydration';

/**
 * LabsProvider is a thin wrapper that handles URL hydration.
 * All Labs state is managed by Jotai atoms in src/ui/state/LabsAtoms.ts
 */
export const LabsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	// Hydrate state from URL params on mount
	useUrlHydration();

	return <>{children}</>;
};
